import * as types from "./types";
import database from "../config/database";

export function actionCreateAppointment(payload) {
  return {
    type: types.CREATE_APPOINTMENT,
    value: payload
  };
}

export function f_CREATE_Appointment(
  name,
  locationAddress,
  phone,
  language,
  reminded,
  reminderType,
  reminderValue,
  bringingFriend,
  locationID,
  provider,
  timeslotID,
  appointmentTimestamp,
  appointmentTimeQuery,
  contactValue
) {
  return () => {
    const appointmentID = `appointment-${appointmentTimestamp}-${locationID}-${provider}`;
    const appointment = {
      [`${appointmentID}`]: {
        name,
        phone,
        language,
        reminded,
        reminderType,
        reminderValue,
        bringingFriend,
        contactValue,
        locationAddress,
        timeslot: {
          [`${timeslotID}`]: true
        },
        location: locationID,
        appointmentTimeQuery,
        appt_was_scheduled: new Date(),
        confirmed: false
      }
    };
    database
      .ref("/app/appointments")
      .update({
        ...appointment
      })
      .then(() => {
        const updatedAppointment = {
          [`${appointmentID}`]: true
        };

        database.ref(`/app/timeslots/${timeslotID}`).update({
          appointment: updatedAppointment
        });
      });
  };
}

export function actionUpdateAppointment(payload) {
  return {
    type: types.UPDATE_APPOINTMENT,
    value: payload
  };
}

export function f_UPDATE_Appointment(
  reminderType,
  appointmentTimestamp,
  locationID,
  provider,
  contactValue
) {
  return () => {
    database
      .ref(
        `/app/appointments/appointment-${appointmentTimestamp}-${locationID}-${provider}`
      )
      .update({
        reminderType,
        contactValue
      });
  };
}
